import { mutatorAction } from 'satcheljs';
import type RibbonFormatState from '../store/schema/RibbonFormatState';
import type { ModeIndependentColor } from 'roosterjs-editor-types';

const setLastTextColor = mutatorAction(
    'Ribbon_SetLastTextColor',
    (formatState: RibbonFormatState, color: ModeIndependentColor) => {
        formatState.lastTextColors = color;
    }
);

export default setLastTextColor;
